import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Dropdown, DuotonePicker, DuotoneSwatch, MenuGroup, ToolbarButton } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { DOWN } from '@wordpress/keycodes';
import { Icon, filter } from '@wordpress/icons';

function DuotoneControl(_ref) {
  let {
    colorPalette,
    duotonePalette,
    disableCustomColors,
    disableCustomDuotone,
    value,
    onChange
  } = _ref;
  return createElement(Dropdown, {
    popoverProps: {
      className: 'block-editor-duotone-control__popover',
      headerTitle: __('Duotone'),
      isAlternate: true
    },
    renderToggle: _ref2 => {
      let {
        isOpen,
        onToggle
      } = _ref2;

      const openOnArrowDown = event => {
        if (!isOpen && event.keyCode === DOWN) {
          event.preventDefault();
          onToggle();
        }
      };

      return createElement(ToolbarButton, {
        showTooltip: true,
        onClick: onToggle,
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        onKeyDown: openOnArrowDown,
        label: __('Apply duotone filter'),
        icon: value ? createElement(DuotoneSwatch, {
          values: value
        }) : createElement(Icon, {
          icon: filter
        })
      });
    },
    renderContent: () => createElement(MenuGroup, {
      label: __('Duotone')
    }, createElement("div", {
      className: "block-editor-duotone-control__description"
    }, __('Create a two-tone color effect without losing your original image.')), createElement(DuotonePicker, {
      colorPalette: colorPalette,
      duotonePalette: duotonePalette,
      disableCustomColors: disableCustomColors,
      disableCustomDuotone: disableCustomDuotone,
      value: value,
      onChange: onChange
    }))
  });
}

export default DuotoneControl;
//# sourceMappingURL=index.js.map